<script setup lang="ts">
import Quill from "quill";

const editorRef = inject("quillEditor") as any;

const setIndent = (value: "+1" | "-1") => {
  const quill = editorRef.value?.getQuill?.();
  if (!quill) return;

  const selection = quill.getSelection(true);
  if (!selection) return;

  quill.format("indent", value, Quill.sources.USER);
};
</script>

<template>
  <BasePopover
    align="start"
    trigger-class="!w-[30px] !h-[30px] !p-0 rounded"
  >
    <div
      v-tooltip="'Indentation'"
      aria-label="Indentation options"
      class="w-[30px] h-[30px] rounded hover:bg-light flex items-center justify-center"
    >
      <icon name="lucide:indent-increase" size="16" />
    </div>
    <template #content>
      <div class="p-2">
        <div class="font-semibold pb-2 border-b mb-2 text-body-2">
          Indentation
        </div>
        <div class="flex items-center gap-1">
          <BaseIconButton
            tooltip="Decrease Indent"
            aria-label="Decrease indent"
            @mousedown.prevent.stop="setIndent('-1')"
          >
            <icon name="lucide:indent-decrease" size="16" />
          </BaseIconButton>
          <BaseIconButton
            tooltip="Increase Indent"
            aria-label="Increase indent"
            @mousedown.prevent.stop="setIndent('+1')"
          >
            <icon name="lucide:indent-increase" size="16" />
          </BaseIconButton>
          <div class="h-5 w-px bg-medium-tint/30 mx-1" />
          <BaseWordProcessorToolbarHangingIndent />
        </div>
      </div>
    </template>
  </BasePopover>
</template>
